module.exports = __webpack_public_path__ + "static/logo-2f7eecf34d670678989ce97b5f97bf95.png";